import { Component, OnInit, ViewChild, TemplateRef, Input, OnDestroy } from '@angular/core';
import { UserService } from '../core/services/user.service';
import { FesBaseComponent } from '../shared/components/fes-base.component';
import { AppState } from '../core/app-state';
import { BsModalService } from 'ngx-bootstrap/modal';
import { UserEditComponent } from './user-edit/user-edit.component';
import { UserDoc } from '../core/schema/user-schema';
import { LookupService } from '../core/services/lookup.service';
import { ConfirmModalComponent } from '../shared/components/confirm-modal/confirm-modal.component';
import { AppTab } from '../core/app-tab';


@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.scss']
})
export class UserListComponent extends FesBaseComponent implements OnInit, OnDestroy {

  @Input() set tabConfig( tabConfig : AppTab ) {
    tabConfig.setSelected = this.onTabSelected
  }

  @ViewChild('editTemplate', { static: true }) editTemplate: TemplateRef<any>;

  users : UserDoc[] = []
  isLoading : boolean = false;
  errorMsg: string = "";
  testOutput:any = ""

  constructor(
    public appState: AppState, 
    private userService:UserService, 
    private lookupService: LookupService,
    private bsModalService: BsModalService ) { 
    super(appState)
  }

  ngOnInit(): void {
    //this.initialize()
  }

  ngOnDestroy(): void {
    this.destroy()
  }

  initialize() {
    this.isLoading = true
    this.userService.doWhenReady( () => {
      const userQuery = this.userService.rxCollection.find()
      this.subscribe( 
        userQuery.$,
        async users => {
          console.log('user list changed')
          await this.updateUserList(users)
          this.isLoading = false
        },
        error => {
          this.isLoading = false
          this.userService.publishError(error,this)
        }
      )
    })
  }

  onTabSelected = ( bSelected : boolean ) => {
    console.log('user-list tab selected: ' + bSelected )
    if ( bSelected ) {
      this.initialize()
    } else {
      this.unsubscribe()
    }
  }
  
  async updateUserList( users : UserDoc[]) {
    try {
      const roles = await this.lookupService.getRoles()
      for ( let i = 0; i < users.length; i++ ) {
        let user = users[i]
        let userObj = (user as any)
        if ( userObj.fullName === undefined ) { // needed for sorting and filtering
          userObj.fullName = ''
          user.get$('firstName').subscribe( firstName => userObj.fullName = firstName + ' ' + user.lastName )
          user.get$('lastName').subscribe( lastName => userObj.fullName = user.firstName + ' ' + lastName )
        }
      }
      this.users = users    
    } catch ( error ) {
      this.userService.publishError(error,this)
    } finally {
    }
  }

  editUser( user : UserDoc ) {
    const initialState = {
      user: user      
    }
    this.bsModalService.show(UserEditComponent, {ignoreBackdropClick: true, initialState});
  }

  deleteUser( user : UserDoc ) {
    let initialState = { 
      onYes: () => { 
        this.userService.deleteUserById(user._id).subscribe(
          resp => { this.userService.syncNow() },
          error => this.userService.publishError(error,this)
      )},
      question: `Delete user ${user.firstName} ${user.lastName} (${user.email})?`,
      focusOnNo: true,
      yesStyle: 'btn btn-danger'
    }
    this.bsModalService.show(ConfirmModalComponent, {initialState} );
  }

}
